import { customShadows } from '../custom-shadows';
import palette from '../palette';

export function createContrast(contrast: 'default' | 'bold', mode: 'light' | 'dark') {
  const theme = {
    ...(contrast === 'bold' &&
      mode === 'light' && {
        palette: {
          background: {
            default: palette.light.grey[200],
          },
        },
      }),
  };

  const components = {
    ...(contrast === 'bold' && {
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: customShadows.light.z1,
          },
        },
      },
    }),
  };

  return {
    ...theme,
    components,
  };
}
